module.exports = __webpack_public_path__ + "static/ads-806b1a3192c613bc0547e271694b5629.png";